import React from 'react';

import Typography from '../../library/typography/typography';

import './static-quantity.scss';

interface StaticQuantityProps {
  className?: string;
  isHorizontal?: boolean;
  quantity: number;
  variant?: string;
}

function StaticQuantity(props: StaticQuantityProps) {
  const {
    className = '',
    isHorizontal = false,
    quantity,
    variant = 'P'
  } = props;

  if (isNaN(quantity)) {
    return null;
  }

  if (isHorizontal) {
    return (
      <Typography
        className={`static-quantity ${className}`}
        styleName="horizontal-container"
        tag="span"
        variant={variant}
      >
        <span>QTY</span> &nbsp;&nbsp;{quantity}
      </Typography>
    );
  }

  return (
    <Typography
      className={`static-quantity ${className}`}
      styleName="container"
      tag="div"
    >
      <span className="static-quantity__label" styleName="quantity-label">
        qty
      </span>
      <span className="static-quantity__value" styleName="quantity-value">
        {quantity}
      </span>
    </Typography>
  );
}

export default StaticQuantity;
